/////////////////////////////////////////////////V5CommentStart
// 2023 copy of featuredlinks class found in frontpage.js
// 2023-01-15 - Dirty version - two towers moved to singleblog posts
// 2023-01-28 - cleaner blogview
// 2023-03-04 - big tidy up

/////////////////////////////////////////////////V5CommentEnd import React from 'react'
import React from 'react'
import { Button, Grid, Row, Col} from 'react-bootstrap'
import './SingleBlogPost.css'
import {getBlogPostsREST } from '../../utils/rest'
import ScriptTag from 'react-script-tag'
 
//https://softwareengineering.stackexchange.com/questions/321534/what-json-structure-to-use-for-key-value-pairs
var makesJSON=
[

  {'make': 'Acura','href': '/research/2024-Acura-models'},
  {'make': 'Alfa Romeo','href': '/research/2024-Alfa_Romeo-models'},
  {'make': 'Aston Martin','href': '/research/2024-Aston_Martin-models'},
  {'make': 'Audi','href': '/research/2024-Audi-models'},
  {'make': 'Bentley','href': '/research/2024-Bentley-models'},
  {'make': 'BMW','href': '/research/2024-BMW-models'},
  {'make': 'Buick','href': '/research/2024-Buick-models'},
  {'make': 'Cadillac','href': '/research/2024-Cadillac-models'},
  {'make': 'Chevrolet','href': '/research/2024-Chevrolet-models'},
  {'make': 'Chrysler','href': '/research/2024-Chrysler-models'},
  {'make': 'Dodge','href': '/research/2024-Dodge-models'},
  {'make': 'Ford','href': '/research/2024-Ford-models'},
  {'make': 'Genesis','href': '/research/2024-Genesis-models'},
  {'make': 'GMC','href': '/research/2024-GMC-models'},
  {'make': 'Honda','href': '/research/2024-Honda-models'},
  {'make': 'Hyundai','href': '/research/2024-Hyundai-models'},
  {'make': 'INFINITI','href': '/research/2024-INFINITI-models'},
  {'make': 'Jaguar','href': '/research/2024-Jaguar-models'},
  {'make': 'Jeep','href': '/research/2024-Jeep-models'},
  {'make': 'Kia','href': '/research/2024-Kia-models'},
  {'make': 'Lamborghini','href': '/research/2024-Lamborghini-models'},
  {'make': 'Land Rover','href': '/research/2024-Land_Rover-models'},
  {'make': 'Lexus','href': '/research/2024-Lexus-models'},
  {'make': 'Lincoln','href': '/research/2024-Lincoln-models'},
  {'make': 'Lucid','href': '/research/2024-Lucid-models'},
  {'make': 'Maserati','href': '/research/2024-Maserati-models'},
  {'make': 'Mazda','href': '/research/2024-Mazda-models'},
  {'make': 'McLaren','href': '/research/2024-McLaren-models'},
  {'make': 'Mercedes-Benz','href': '/research/2024-Mercedes-Benz-models'},
  {'make': 'MINI','href': '/research/2024-MINI-models'},
  {'make': 'Mitsubishi','href': '/research/2024-Mitsubishi-models'},
  {'make': 'Nissan','href': '/research/2024-Nissan-models'},
  {'make': 'Polestar','href': '/research/2024-Polestar-models'},
  {'make': 'Porsche','href': '/research/2024-Porsche-models'},
  {'make': 'Ram','href': '/research/2024-Ram-models'},
  {'make': 'Rivian','href': '/research/2024-Rivian-models'},
  {'make': 'Rolls-Royce','href': '/research/2024-Rolls-Royce-models'},
  {'make': 'Subaru','href': '/research/2024-Subaru-models'},
  {'make': 'Tesla','href': '/research/2024-Tesla-models'},
  {'make': 'Toyota','href': '/research/2024-Toyota-models'},
  {'make': 'Volkswagen','href': '/research/2024-Volkswagen-models'},
  {'make': 'Volvo','href': '/research/2024-Volvo-models'},
  {'make': 'Wagoneer','href': '/research/2024-Wagoneer-models'}

]
 ;

//---------------------------------------
// MODELSJSON data structures pushed to a section
//---------------------------------------
export const DumpModels = ({ passedJSONdata }) => {
  var list = JSON.parse(passedJSONdata)
  //console.log("dirtbike2-" + passedJSONdata.make)
  //console.log("dirtbike3-" + list[0].make)
  return (
    <Row>
      <Col xs={12}>
        {
          list.map((v, k) =>
          (
            <div  >
              {list[k].make + ' ' + list[k].model}  -
              <a href={list[k].URL_INVENTORY}  > View Local Inventory</a>,       
              <a href={list[k].URLMODEL} >View Model Details</a>,
              Recent Inventory Prices:* 
              Low Price - {list[k].lowPrice === 0 ? 'N/A' : `$${Number(list[k].lowPrice).toLocaleString()}`},
              Avg Price - {list[k].avgPrice === 0 ? 'N/A' : `$${Number(list[k].lowPrice).toLocaleString()}`},
              Max Price - {list[k].maxPrice === 0 ? 'N/A' : `$${Number(list[k].lowPrice).toLocaleString()}`}
              <br></br>
            </div>
          )
          )
        }

      </Col>
      <i>*See dealers for details on pricing on specific vehicles</i>
    </Row>
    



  )
}
 
//---------------------------------------
// 
//---------------------------------------
export const DumpModelTrims = ({ passedJSONdata }) => {
  var list = JSON.parse(passedJSONdata)
  
  return (
    <Row>
      <Col xs={12}>
        {
          list.map((v, k) =>
          (
            <div  >
              {list[k].make + ' ' + list[k].model + ' ' + list[k].trim}
              <br></br>
            </div>
          )
          )

        }
      </Col>
    </Row>
  )
}

//---------------------------------------
// 
//---------------------------------------
export const DumpMakes = ({ passedJSONdata }) => {
  /// this is ok. but not what i want

  const n = Math.ceil(makesJSON.length / 3)
  const list = [
    makesJSON.slice(0, n),
    makesJSON.slice(n, n * 2),
    makesJSON.slice(n * 2),
  ]

  return (
    <Grid>
      <Row>
        {
          makesJSON.map((v, k) =>
          (
            <div class="col-2 col-md-3 col-sm-4 col-xs-6 " >
              <Button style={{ margin: '5px', width: '120px' }} href={makesJSON[k].href} className="textColor bgColor">{makesJSON[k].make}</Button>
            </div>
          )
          )
        }
      </Row>



    </Grid>
)
}
       
//---------------------------------------
// 
//---------------------------------------

export const DumpOptions = ({ passedJSONdata }) => {
  
  const item = JSON.parse(passedJSONdata);
  const n = Math.ceil(item.options.length / 3)
  const list = [
    item.options.slice(0, n),
    item.options.slice(n, n * 2),
    item.options.slice(n * 2),
  ]

  return (

    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={12} sm={4}>

            <ul>
              {' '}
              {list[0].map((v, k) => <li key={k}> {v} </li>)}{' '}
            </ul>
          </Col>
          <Col xs={12} sm={4}>
            <ul>
              {' '}
              {list[1].map((v, k) => (
                <li key={list[0].length + k}> {v} </li>
              ))}{' '}
            </ul>
          </Col>
          <Col xs={12} sm={4}>
            <ul>
              {' '}
              {list[2].map((v, k) => (
                <li key={list[0].length + list[1].length + k}>
                  {' '}
                  {v}
                </li>
              ))}{' '}
            </ul>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}


//---------------------------------------
// 
//---------------------------------------

class SingleBlogPost extends React.PureComponent {
  state = {}
  reload = false

  componentWillReceiveProps() {
    this.reload = true
  }

  componentDidMount() {
    this.load()
  }

  componentDidUpdate() {
    if (this.reload) {
      this.load()
      this.reload = false
    }
  }


  //---------------------------------------
  // ddfix, needs all kinds of error handling
  // what parameters are needed
  // Be mindful this function is getting called by componentdidupdate 
  //---------------------------------------
  load = () => {
    const { zipCode, redirURL  } = this.props

    getBlogPostsREST(zipCode, redirURL)
      .then(sockPuppets => {
        const {  blogPosts } = sockPuppets
        this.setState({ blogPosts })

        //console.log(`CFD_FUNC_SingleBlogPostLoad:burrito1-` + zipCode + '-' );
        //console.log(`CFD_FUNC_SingleBlogPostLoad:burrito2-` + zipCode + '-' + this.state.blogPosts);
        //console.log(`CFD_FUNC_SingleBlogPostLoad:burrito3-` + zipCode + '-' + this.state.blogPosts[0].blogLayout);
      }
      )
      .catch(err => {
        throw new Error(`SBP Load ERROR!!!: ${err}`)
      })
  }

    // ok. you want 1 or 2 'towers', so you need to spool it out in sets.
    // but its not stored as set in the database
    // a bit stupid either way, is it better to futz with packing it into objects then push ?
    // or deal with a denormalized set of data, that needs to be bunched?
    //---------------------------------------
    //  Push all sections for that catalog item out
    //  this is FUNCTION that gets CALLED by the JSX, but a promise return makes this rerender
    //  state changes. need to do nothing until you get the data
    // 
    //---------------------------------------
    blogPostsMap = i => {
         
    if ((!this.state.blogPosts                     )  ||
       (this.state.blogPosts.length === 0         )  ||
       (i < 0 || i >= this.state.blogPosts.length )  ||
       (!this.state.blogPosts[i].blogContentArray )  )
      {
        console.log('CFD_SINGLEBLOGPOST - caught up in the mapping somehow'  );
        return  null
      }
    try {
    return (
      <Row    >
         {/* this.state.blogPosts[i].blogLayout != 'RIGHT' &&  
          (          <div class="blogBreadCrumb">this is the bread crumb</div>
          ) 
    */}
        <div class="blogMainTitle"><h2>{this.state.blogPosts[i].blogTitle}</h2></div>
        
        {
          this.state.blogPosts[i].blogContentArray.map(({ sectionSequence, sectionBody, sectionBodyFormat, sectionHeading, sectionProject }) =>
          (
            <div  style={{ margin:'10px'}} >
              {  // toggle debugging
                1 == 31 &&
                (
                  <Col className="aside" key={sectionSequence} style={{ color: 'orangered' }} >

                    <aside>Rowdebuggerx-{this.state.blogPosts[i].blogID}-{sectionSequence} -{sectionBodyFormat} -{sectionProject} </aside>
                  </Col>
                )
              }
              {
                sectionHeading &&
                (
                  <div class="blogSectionTitle"><h3>{sectionHeading}</h3></div>
                )
              }
              {
                sectionBodyFormat == 'DANGEROUS' && sectionBody &&
                (
                  <Col key={sectionBody} >
                    {/*<div   style={{border: '5px solid cyan' , height: '260px'} }  id="bud-feeder" data-bodytype="Hatchback" data-pricerange="15000,25000" class="dt-actionable"></div> */}
                    <div className="css-fix" dangerouslySetInnerHTML={{ __html: sectionBody }} ></div>
                  </Col>
                )
              }
              {
                sectionBodyFormat == 'MAKELIST' && 
                (
                  <DumpMakes passedJSONdata={sectionBody}>
                  </DumpMakes>
                )
              }
              {
                sectionBodyFormat == 'MODELSDETAILJSON' && sectionBody &&
                (
                  <DumpOptions passedJSONdata={sectionBody}>
                  </DumpOptions>
                )
              }
              {
                sectionBodyFormat == 'MODELSJSON' && sectionBody &&
                (
                  <DumpModels passedJSONdata={sectionBody}>
                  </DumpModels>
                )
              }
              {
                sectionBodyFormat == 'MODELSTRIMSJSON' && sectionBody &&
                (
                  <DumpModelTrims passedJSONdata={sectionBody}>
                  </DumpModelTrims>
                )
              }
              {
                //this.state.blogPosts[i].blogID ==916 && sectionSequence==334 && sectionBody &&
                sectionBodyFormat == 'OPTIONSJSON' && sectionBody &&
                (
                  <DumpOptions passedJSONdata={sectionBody}>
                  </DumpOptions>
                )
              }
            </div>
          )
          )
        }
      </Row>
    ) // return
      }
      catch (error)
      {
        console.error('Failed in JSX for SBP', error);
        return
      }


  }//  make the JSX out of the array 

  //---------------------------------------
  //  the array will have 1 elements in the array - The Primary and the optional right side
  //---------------------------------------
  // this render seems to be triggered multiple times. so you need to be careful as the promise comes back there will be different
  // returning empty  
  render() 
  {
    // this banging against this while the promise is working
    if (!this.state.blogPosts) {
      return null;
    }   
     
    else if (this.state.blogPosts[0].blogLayout === 'ONE_COLUMN')
      return (

        <Grid
          fluid componentClass="aside" className="SingleBlogPost">
          <Row>
            <ScriptTag
              type="text/javascript"
              src="https://www.rydeshopper.com/app/shoppingtools/scripts/widget-inline.js"
            />
            {/* 
              src="https://www.rydeshopper.com/app/shoppingtools/scripts/widget-inline.js?gid=0000-2596"
            */ }
            {/*  these were 12 before   splitting as part of the test
                Total is 12... lg seems to be big 
          */ }
            <Col
              xs={12}
              xsOffset={0}
              sm={12}
              smOffset={0}
              md={12}
              mdOffset={0}
              lg={12}
              lgOffset={0}
            >
              {this.blogPostsMap(0)}
            </Col>
          </Row>
        </Grid>
      ) // one column return 
      else if (this.state.blogPosts[0].blogLayout === 'TWO_COLUMN')
      return (
        <Grid
          fluid componentClass="aside" className="SingleBlogPost">
          <Row>
            <ScriptTag
              type="text/javascript"
              src="https://www.rydeshopper.com/app/shoppingtools/scripts/widget-inline.js"
              
            />
       {/* 
              src="https://www.rydeshopper.com/app/shoppingtools/scripts/widget-inline.js?gid=0000-2596"
            */ }
 
            {/*  these were 12 before   splitting as part of the test
                Total is 12... lg seems to be big 
          */ }
            <Col
              xs={12}
              xsOffset={0}
              sm={12}
              smOffset={0}
              md={7}
              mdOffset={0}
              lg={8}
              lgOffset={0}
            >
              {this.blogPostsMap(0)}
            </Col>
            {/*   this is the second column that needs to moved around*/}
            <Col 
              xs={12}
              xsOffset={0}
              sm={12}
              smOffset={0}
              md={3}
              mdOffset={1}
              lg={3}
              lgOffset={0}
            >
              {this.blogPostsMap(1)}

            </Col>
          </Row>

        </Grid>
      )  // TWO column return finish
      else 
      return (
      <div>
            <br></br>Sorry, there was an issue fulfilling your request. 
            <br></br><a href="/research">Click here to go back </a>      
      </div>
           
      )

  }
}
export default SingleBlogPost


// WEBPACK FOOTER //
// ./src/components/BlogView/SingleBlogPost.js